import { errorCodes } from '.';

export class CommandResult{
    constructor(){
        this.isSuccess = true;
        this.errorMessage = '';
    }

    isSuccess:boolean;
    errorMessage:errorCodes;

    static succeeds():CommandResult{
        const result = new CommandResult();
        result.isSuccess = true;
        result.errorMessage = '';
        return result;
    }

    static fails(errorCode:errorCodes):CommandResult{
        const result = new CommandResult();
        result.isSuccess = false;
        result.errorMessage = errorCode;
        return result;
    }
}

